export const favorites = {
  title: "Mis favoritos",
  subtitle: "{{count}} alojamientos guardados",
  countries: "Países",
  cities: "Ciudades",
  emptyTitle: "Ningún favorito por el momento",
  emptyFiltered: "Intenta modificar tus filtros para ver tus favoritos.",
  emptyState:
    "Explora nuestros alojamientos únicos y añádelos a tus favoritos para encontrarlos aquí.",
  noFavoritesYet: "Ningún favorito por el momento",
  exploreMembersMap: "Explora el mapa de miembros para encontrar alojamientos",
  exploreMap: "Explorar el mapa",
  backToHome: "Volver al inicio",
  howToAddFavorites: "¿Cómo añadir favoritos?",
  step1: "Ve a la",
  step2: "mapa de miembros",
  step3: "y haz clic en el corazón",
  step3End: "para añadir un alojamiento a tus favoritos",
  membersMapLink: "Mapa de miembros",
  properties: "propiedades",
  selected: "seleccionadas",
  compare: "Comparar",
  actions: "Acciones",
  contact: "Contactar",
  exchange: "Proponer un intercambio",
  removeFromFavorites: "Quitar de favoritos",
  removeFromComparison: "Quitar de la comparación",
  owner: "Propietario",
  ratingLabel: "Nota",
  exchangesLabel: "Intercambios",
  exchangesCount: "intercambios",
  exchangesCompleted: "intercambios realizados",
  capacityLabel: "Capacidad",
  guestsCount: "viajeros",
  numberOfRooms: "habitaciones",
  roomsCount: "habitaciones",
  onlineStatus: "En línea",
  onlineBadge: "En línea",
  verifiedStatus: "Verificado",
  verifiedBadge: "Verificado",
  no: "No",
};
